import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../context/AuthContext";

let internetPlansRequestKey = "";
let internetPlansRequest = null;

const loadInternetPlans = (accessToken, username) => {
  const requestKey = `${username}:${accessToken}`;

  if (
    !internetPlansRequest ||
    internetPlansRequestKey !== requestKey
  ) {
    internetPlansRequestKey = requestKey;
    internetPlansRequest = Axios.get(
      `${API_URL}/radius/plans/internet`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        params: { username },
      },
    )
      .then((response) => response.data)
      .catch((error) => {
        if (internetPlansRequestKey === requestKey) {
          internetPlansRequest = null;
        }
        throw error;
      });
  }

  return internetPlansRequest;
};

export const prefetchInternetPlans = (
  accessToken,
  username,
) => {
  loadInternetPlans(accessToken, username).catch((error) => {
    console.error("Error prefetching internet plans:", error);
  });
};

function Formsa(props) {
  const [message, setMessage] = useState(null);

  let intsub = props.intsu;
  console.log(intsub);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  let { user } = useContext(AuthContext);
  let intplan = props.intpa;
  let sub = props.su;
  const [subDiscounts, setSubDiscounts] = useState([]);
  const discountLine = (d) =>
    document.documentElement.lang === "ar"
      ? `${d.username} لديه خصم بقيمة ${Number(d.amount)} (${Number(d.percentage)}%)`
      : `${d.username} has a discount of ${Number(d.amount)} (${Number(d.percentage)}%)`;
  useEffect(() => {
    if (!sub) return;
    Axios.get(`${API_URL}/radius/subscriptions/discounts/`, {
      headers: { Authorization: `Bearer ${authTokens.access}` },
      params: { username: user.username, subscription_ids: String(sub) },
    })
      .then((response) =>
        setSubDiscounts(Array.isArray(response.data) ? response.data : [])
      )
      .catch(() => setSubDiscounts([]));
  }, [sub]);
  let u = props.usr;
  let f = props.full;
  let s = props.sit;
  let c = props.con;
  let o = props.opti;
  let p = props.plana;
  let exp = props.exp;
  let du = props.due;
  let site_name = props.site;
  let w = props.WAP;
  let paymentDate = props.paymentDate;
  let core = props.core;
  let cpe = props.cpe_mac; // CPE Variable
  const currentQuota = props.quota || "";
  const currentFull = Number(props.isFull) === 1 ? 1 : 0;
  const currentSuffix = props.suffix || "";
  const currentLabelsText = props.labelsText || "";
  console.log(exp);

  const [username, setusername] = useState(u || "");
  const [pass] = useState(props.pass || "");

  const [password, setpassword] = useState(props.pass || "");
  const [site, setsite] = useState(s || "");
  const [due, setdue] = useState(du || "");
  const [suffix, setsuffix] = useState(currentSuffix);

  const [subnotes] = useState("");
  const [label, setlabel] = useState(null);
  let [labels, setlabels] = useState([]);
  let [full_option, setfull] = useState(currentFull);

  const [consumption_option, setcon] = useState(o || "");
  const [quota_option, setquota] = useState(currentQuota);

  const [connectivity, setcona] = useState(c || "");
  const [expiration_date, setda] = useState(
    exp ? exp.substr(0, 10) : "",
  );
  const [payment_date, setpa] = useState(
    paymentDate ? paymentDate.substr(0, 10) : "",
  );

  const [expiryDateDisabled, setExpiryDateDisabled] = useState(true);
  let [plans, setplans] = useState([]);
  const [client, setclient] = useState(null);
  const [plani, setplano] = useState(intplan || "");
  let [notes, setcil] = useState([]);

  const [clients, setClients] = useState([]);
  const [usernames, setUsernames] = useState([]);
  const [consumptionDisabled, setConsumptionDisabled] = useState(false);
  const [wirelessAccessPoint, setWirelessAccessPoint] = useState("");
  const [selectedWirelessAccessPointLabel, setSelectedWirelessAccessPointLabel] =
    useState(w || "");
  const [sites, setSites] = useState([]);
  const [wirelessAccessPoints, setWirelessAccessPoints] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [cores, setCores] = useState([]);
  const [selectedCore, setSelectedCore] = useState("");
  const [selectedCoreLabel, setSelectedCoreLabel] = useState(core || "");
  const [isSaving, setIsSaving] = useState(false);
  const [downgradeCase, setDowngradeCase] = useState(null);
  const [pendingDowngradeChanges, setPendingDowngradeChanges] = useState(null);
  const [downgradeReason, setDowngradeReason] = useState("");
  const [downgradeReasonOpen, setDowngradeReasonOpen] = useState(false);
  const [upgradeQuote, setUpgradeQuote] = useState(null);
  const [freeSub, setFreeSub] = useState(false);
  const [unlimitedFee, setUnlimitedFee] = useState(null);
  const [pendingUnlimitedChanges, setPendingUnlimitedChanges] =
    useState(null);
  const [pendingUnlimitedQuote, setPendingUnlimitedQuote] =
    useState(null);
  const [pendingUpgradeChanges, setPendingUpgradeChanges] =
    useState(null);

  const [testingClient, setTestingClient] = useState(false);
  const [testingClientPending, setTestingClientPending] =
    useState(false);
  const [testingClientLoading, setTestingClientLoading] =
    useState(true);

  React.useEffect(() => {
    let active = true;

    const loadTestingClientState = async () => {
      setTestingClientLoading(true);

      if (sub == null || sub === "") {
        if (active) {
          setTestingClient(false);
          setTestingClientPending(false);
          setTestingClientLoading(false);
        }
        return;
      }

      try {
        const storedTokens = JSON.parse(
          localStorage.getItem("authTokens") || "{}",
        );
        const response = await Axios.get(
          `${API_URL}/radius/testing-clients/`,
          {
            headers: {
              Authorization: `Bearer ${storedTokens.access}`,
            },
            params: {
              subscription_id: sub,
            },
          },
        );
        const pending = (
          response.data?.results || []
        ).length > 0;

        if (active) {
          setTestingClient(pending);
          setTestingClientPending(pending);
        }
      } catch (error) {
        console.error(error);
        if (active) {
          setTestingClient(false);
          setTestingClientPending(false);
        }
      } finally {
        if (active) {
          setTestingClientLoading(false);
        }
      }
    };

    loadTestingClientState();

    return () => {
      active = false;
    };
  }, [sub]);

  const [cpeMacAddress, setCpeMacAddress] = useState(""); // New State
  const [cpeError, setCpeError] = useState(""); // New State

  const [selectedSiteLabel, setSelectedSiteLabel] = useState(
    site_name || "",
  );

  const specialSites = ["AYSAR", "EZONE", "SAEED"];

  console.log(expiration_date);
  console.log(plani);
  console.log(client);
  console.log(expiryDateDisabled);
  useEffect(() => {
    let isMounted = true;

    const getclients = async () => {
      try {
        const response = await Axios.get(`${API_URL}/administration/clients/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setcil(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getplans = async () => {
      try {
        const planData = await loadInternetPlans(
          authTokens.access,
          user.username,
        );

        if (isMounted) {
          setplans(planData);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const getlabels = async () => {
      try {
        const response = await Axios.get(`${API_URL}/administration/labels/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setlabels(response.data);
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const getpermisions = async () => {
      try {
        const response = await Axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setExpiryDateDisabled(response.data === "yes");
        }
      } catch (error) {
        console.error(error);
      }
    };
    getpermisions();
    getclients();
    getplans();
    getlabels();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const fetchSites = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/sites/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username },
        });

        if (response.status === 200) {
          const options = response.data.map((item) => ({
            label: item.site_name,
            value: item.site_id,
          }));
          setSites(options);
        }
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    fetchSites();

    const fetchCores = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/radius/fiber/cores/select/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: { username: user.username },
          },
        );

        if (response.status === 200) {
          const options = response.data.map((item) => ({
            label: item.code,
            value: item.core_id,
          }));
          setCores(options);
        }
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    fetchSites();
    fetchCores();
  }, [authTokens.access, user.username]);

  const fetchWirelessAccessPoints = async (siteName) => {
    try {
      const response = await Axios.get(
        `${API_URL}/radius/wirelessAccessPoint/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username, site: siteName },
        },
      );

      if (response.status === 200) {
        const options = response.data.map((item) => ({
          label: item.name,
          value: item.ap_id,
        }));
        setWirelessAccessPoints(options);

        if (specialSites.includes(siteName)) {
          const defaultOption = options.find((opt) => opt.label === siteName);
          if (defaultOption) {
            setWirelessAccessPoint(defaultOption.value);
            setSelectedWirelessAccessPointLabel(defaultOption.label);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching wireless access points:", error);
    }
  };

  const options = notes.map((item) => {
    return {
      label: item.fullname_en,
      value: item.client_id,
    };
  });

  const plano = plans.map((item) => {
    return {
      label: item.plan_name,
      value: item.internet_plan_id,
    };
  });
  const labelss = labels.map((item) => {
    return {
      label: item.label_name,
      value: item.label_id,
    };
  });

  const originalLabelNames = currentLabelsText
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean)
    .sort();

  const selectedLabelOptions =
    label === null
      ? labelss.filter((option) => originalLabelNames.includes(option.label))
      : labelss.filter((option) => label.includes(option.value));

  const opta = [
    { value: "LIMITED", label: "LIMITED" },
    { value: "UNLIMITED", label: "UNLIMITED" },
  ];
  const quota = [
    { value: "single", label: "Single" },
    { value: "double", label: "Double" },
    { value: "triple", label: "Triple" },
  ];
  const cona = [
    { value: "Fiber", label: "Fiber" },
    { value: "Wireless", label: "Wireless" },
  ];
  const dua = [
    { value: "First", label: "First" },
    { value: "Half", label: "Half" },
  ];

  // Function to show the message for a given duration
  const showMessage = (message, type = "success", closeAfter = false) => {
    setMessage({ text: message, type });

    if (closeAfter) {
      setTimeout(() => {
        props.closeModal();
      }, 1200);
    }

    setTimeout(() => {
      setMessage(null);
    }, 3000);
  };

  const hasChanged = (current, original) =>
    String(current ?? "") !== String(original ?? "");

  const changedNonEmptyValue = (current, original) =>
    String(current ?? "") !== "" && hasChanged(current, original);

  const getChangedFields = () => {
    const usernameValue = username.trim().toLowerCase();
    const originalUsername = String(u || "").trim().toLowerCase();

    const clientChanged =
      client !== null && String(client.label) !== String(f || "");

    const planChanged =
      plani !== "" && String(plani) !== String(intplan || "");

    const accessPointChanged =
      wirelessAccessPoint !== "" &&
      selectedWirelessAccessPointLabel !== String(w || "");

    const coreChanged =
      selectedCore !== "" && selectedCoreLabel !== String(core || "");

    return {
      username:
        usernameValue !== "" && usernameValue !== originalUsername
          ? usernameValue
          : "",
      client_id: clientChanged ? client.value : "",
      plan_id: planChanged ? plani : "",
      consumption_option: hasChanged(consumption_option, o)
        ? consumption_option
        : "",
      quota_option: hasChanged(quota_option, currentQuota)
        ? quota_option
        : "",
      connectivity: hasChanged(connectivity, c) ? connectivity : "",
      expiry_date: hasChanged(
        expiration_date,
        exp ? exp.substr(0, 10) : "",
      )
        ? expiration_date
        : "",
      payment_date: hasChanged(
        payment_date,
        paymentDate ? paymentDate.substr(0, 10) : "",
      )
        ? payment_date
        : "",
      site: changedNonEmptyValue(site, s) ? site : "",
      site_id:
        selectedSite !== "" &&
        (accessPointChanged || hasChanged(connectivity, c))
          ? selectedSite
          : "",
      due: hasChanged(due, du) ? due : "",
      suffix: changedNonEmptyValue(suffix, currentSuffix) ? suffix : "",
      full: full_option !== currentFull ? full_option : "",
      label: label === null ? "" : label,
      notes: subnotes,
      password: changedNonEmptyValue(password, pass) ? password : "",
      wireless_access_point_id: accessPointChanged
        ? wirelessAccessPoint
        : "",
      core_id: coreChanged ? selectedCore : "",
    };
  };

  const changedFields = getChangedFields();

  const isDirty =
    (testingClient && !testingClientPending) ||
    label !== null ||
    Object.entries(changedFields).some(
      ([field, value]) => field !== "label" && value !== "",
    );

  const saveSubscription = async (
    fields,
    confirmedQuote = null,
    confirmedUnlimitedFee = null,
    downgradeSettlement = null,
  ) => {
    setIsSaving(true);

    try {
      const response = await Axios.post(
        `${API_URL}/radius/subscriptions/`,
        {
          Action: "Put",
          Subscription_id: sub,
          internet_subscription_id: intsub,
          internet_plan_id: intplan,
          ...fields,
          ...(confirmedQuote
            ? {
                oss_wallet_plan_upgrade: true,
                expected_old_plan_id:
                  confirmedQuote.old_plan_id,
                expected_client_id:
                  confirmedQuote.client_id,
                expected_net_due:
                  confirmedQuote.net_due,
              }
            : {}),
          ...(confirmedUnlimitedFee !== null
            ? {
                expected_unlimited_fee:
                  confirmedUnlimitedFee,
              }
            : {}),
          userdealer: user.username,
        },
        {
          headers: {
            Authorization:
              `Bearer ${authTokens.access}`,
          },
        },
      );

      if (
        typeof response.data === "string" &&
        response.data
          .trim()
          .startsWith("Error:")
      ) {
        throw new Error(
          response.data.trim(),
        );
      }

      const updatedSubscription =
        response.data?.subscription;

      if (
        !updatedSubscription ||
        updatedSubscription
          .subscription_id == null
      ) {
        throw new Error(
          "The backend did not return "
          + "the updated subscription.",
        );
      }

      if (
        typeof props.onSubscriptionUpdated
        === "function"
      ) {
        props.onSubscriptionUpdated(
          updatedSubscription,
        );
      } else if (
        typeof props.fetch === "function"
      ) {
        await props.fetch();
      }

      setUpgradeQuote(null);
      setPendingUpgradeChanges(null);

      let successMessage = "Edit successful!";

      if (downgradeSettlement) {
        try {
          const settleResponse = await Axios.post(
            `${API_URL}/radius/subscriptions/downgrade-settle/`,
            downgradeSettlement,
            {
              headers: {
                Authorization: `Bearer ${authTokens.access}`,
              },
            },
          );
          const settleMessage = settleResponse.data?.message;
          if (settleMessage) {
            successMessage = `${successMessage} ${settleMessage}`;
          }
        } catch (settleError) {
          console.error(settleError);
          showMessage(
            downgradeText("settleFailed")
              + (settleError.response?.data?.error || settleError.message),
            "danger",
          );
          return;
        }
      }

      showMessage(successMessage, "success", true);
    } catch (error) {
      console.error(error);

      if (confirmedQuote) {
        setUpgradeQuote(null);
        setPendingUpgradeChanges(null);
      }

      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "Unable to save the subscription changes.";

      showMessage(
        errorMessage,
        "danger",
      );
    } finally {
      setIsSaving(false);
    }
  };

  const downgradeText = (key, c = downgradeCase) => {
    const ar = document.documentElement.lang === "ar";
    const d = c || {};
    const money = (v) => `$${Number(v || 0).toFixed(2)}`;
    switch (key) {
      case "title":
        return ar ? "تأكيد تخفيض الباقة" : "Confirm Plan Downgrade";
      case "body":
        if (d.case === "unpaid_within") {
          return ar
            ? `سيتم إلغاء فاتورة ${d.old_plan_name} الخاصة بـ ${d.username} (رقم ${d.invoice_id}، ${money(d.amount)}). سيتم إنشاء فاتورة ${d.new_plan_name} بقيمة ${money(d.new_price)}.`
            : `${d.username}'s ${d.old_plan_name} invoice (#${d.invoice_id}, ${money(d.amount)}) will be cancelled. A ${d.new_plan_name} invoice for ${money(d.new_price)} will be created.`;
        }
        if (d.case === "unpaid_late") {
          if (d.days === null || d.days === undefined) {
            return ar
              ? `لدى ${d.username} فاتورة غير مدفوعة (رقم ${d.invoice_id}، ${money(d.amount)}) وسيتم تحصيل المبلغ كاملاً.`
              : `${d.username} has an unpaid invoice (#${d.invoice_id}, ${money(d.amount)}) and will be charged the full amount.`;
          }
          return ar
            ? `${d.username} متأخر ${d.days} يوماً وسيتم تحصيل المبلغ كاملاً (فاتورة رقم ${d.invoice_id}، ${money(d.amount)}).`
            : `${d.username} is ${d.days} days late and will be charged the full amount (invoice #${d.invoice_id}, ${money(d.amount)}).`;
        }
        if (d.case === "paid_within") {
          return ar
            ? `${d.username} دفع ${d.old_plan_name} مسبقاً (فاتورة رقم ${d.invoice_id}). التخفيض إلى ${d.new_plan_name} يضيف ${money(d.credit)} إلى رصيده.`
            : `${d.username} already paid ${d.old_plan_name} (invoice #${d.invoice_id}). Downgrading to ${d.new_plan_name} credits ${money(d.credit)} to his balance.`;
        }
        return "";
      case "partial":
        return ar
          ? `الفاتورة رقم ${d.invoice_id} مدفوعة جزئياً - قم بتسويتها يدوياً أولاً.`
          : `Invoice #${d.invoice_id} is partially paid - settle it manually first.`;
      case "reason":
        return ar ? "سبب إلغاء الفاتورة" : "Reason for cancelling the invoice";
      case "reasonRequired":
        return ar ? "السبب مطلوب." : "A reason is required.";
      case "no":
        return ar ? "لا" : "No";
      case "yes":
        return ar ? "نعم" : "Yes";
      case "continue":
        return ar ? "إبقاء الفاتورة (العميل يدفع)" : "Keep invoice (client pays)";
      case "cancelAndContinue":
        return ar ? "إلغاء الفاتورة (بدون تحصيل)" : "Cancel invoice (no charge)";
      case "back":
        return ar ? "رجوع" : "Back";
      case "confirmCancel":
        return ar
          ? `إلغاء الفاتورة رقم ${d.invoice_id} (بدون تحصيل)`
          : `Cancel invoice #${d.invoice_id} (no charge)`;
      case "reasonIntro":
        return ar
          ? `سيتم إلغاء الفاتورة رقم ${d.invoice_id} (${money(d.amount)}) ولن يتم تحصيل المبلغ من العميل. ما السبب؟`
          : `Invoice #${d.invoice_id} (${money(d.amount)}) will be cancelled and the client will NOT be charged. Why?`;
      case "settleFailed":
        return ar
          ? "تم تغيير الباقة لكن لم تتم تسوية الفاتورة: "
          : "Plan changed, but the invoice was not settled: ";
      case "checkFailed":
        return ar
          ? "تعذر التحقق من تخفيض الباقة."
          : "Unable to check the plan downgrade.";
      default:
        return "";
    }
  };

  const requestDowngradeCase = async (fields) => {
    setIsSaving(true);
    try {
      const response = await Axios.get(
        `${API_URL}/radius/subscriptions/downgrade-preview/`,
        {
          headers: { Authorization: `Bearer ${authTokens.access}` },
          params: { subscription_id: sub, new_plan_id: fields.plan_id },
        },
      );
      const data = response.data || {};
      if (data.error) {
        showMessage(data.error, "danger");
        return undefined;
      }
      if (!data.is_downgrade) {
        return null;
      }
      if (data.case === "partial") {
        showMessage(downgradeText("partial", data), "danger");
        return undefined;
      }
      if (["unpaid_within", "unpaid_late", "paid_within"].includes(data.case)) {
        return data;
      }
      return null;
    } catch (error) {
      console.error(error);
      showMessage(
        error.response?.data?.error || error.message || downgradeText("checkFailed"),
        "danger",
      );
      return undefined;
    } finally {
      setIsSaving(false);
    }
  };

  const cancelDowngrade = () => {
    if (isSaving) return;
    setDowngradeCase(null);
    setPendingDowngradeChanges(null);
    setDowngradeReason("");
    setDowngradeReasonOpen(false);
  };

  const confirmDowngrade = async (action) => {
    if (!downgradeCase || !pendingDowngradeChanges || isSaving) return;
    const reason = downgradeReason.trim();
    if (action === "cancel_invoice" && downgradeCase.case === "unpaid_late" && !reason) {
      showMessage(downgradeText("reasonRequired"), "danger");
      return;
    }
    const fields = { ...pendingDowngradeChanges };
    const settlement = {
      subscription_id: sub,
      old_plan_id: downgradeCase.old_plan_id,
      new_plan_id: downgradeCase.new_plan_id,
      expected_invoice_id: downgradeCase.invoice_id,
      expected_credit: downgradeCase.credit,
      action,
      reason,
    };
    setDowngradeCase(null);
    setPendingDowngradeChanges(null);
    setDowngradeReason("");
    setDowngradeReasonOpen(false);
    await saveSubscription(fields, null, null, settlement);
  };

  const isFreeAccount = async () => {
    try {
      const response = await Axios.post(
        `${API_URL}/radius/subscriptions/bulkactions/`,
        {
          Action: "FreeCheck",
          free_mode: "check",
          sub_id: [sub],
          userdealer: user.username,
          reason: "",
        },
        { headers: { Authorization: `Bearer ${authTokens.access}` } },
      );
      return Array.isArray(response.data?.free) && response.data.free.length > 0;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const freeText = (key) => {
    const ar = document.documentElement.lang === "ar";
    const texts = {
      body: ar ? `${props.usr} لديه حساب مجاني` : `${props.usr} has a free account`,
      ok: ar ? "حسناً" : "OK",
      bill: ar ? "فوترة على أي حال" : "Bill anyway",
      cancel: ar ? "إلغاء" : "Cancel",
    };
    return texts[key];
  };

  const saveFreeNoBill = async (fields) => {
    if (!fields || isSaving) return;
    const freeFields = { ...fields, free_no_bill: true };
    delete freeFields.bill_free;
    setUpgradeQuote(null);
    setPendingUpgradeChanges(null);
    setDowngradeCase(null);
    setPendingDowngradeChanges(null);
    setDowngradeReason("");
    setDowngradeReasonOpen(false);
    setUnlimitedFee(null);
    setPendingUnlimitedChanges(null);
    setPendingUnlimitedQuote(null);
    setFreeSub(false);
    await saveSubscription(freeFields);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isDirty || isSaving) {
      return;
    }

    if (testingClientPending && changedFields.plan_id) {
      showMessage(
        "Resolve the pending Testing Client request before changing its plan.",
        "danger",
      );
      return;
    }

    if (
      testingClient &&
      !testingClientPending &&
      !changedFields.plan_id
    ) {
      showMessage(
        "Choose a higher plan before checking Testing Package.",
        "danger",
      );
      return;
    }

    if (!changedFields.plan_id) {
      const unlimitedUpgrade =
        String(o || "").trim().toUpperCase() === "LIMITED"
        && String(
          changedFields.consumption_option || "",
        ).trim().toUpperCase() === "UNLIMITED";

      if (unlimitedUpgrade) {
        const free = await isFreeAccount();
        setFreeSub(free);
        await requestUnlimitedFee(free ? { ...changedFields, bill_free: true } : changedFields);
        return;
      }

      await saveSubscription(changedFields);
      return;
    }

    if (changedFields.plan_id) {
      const allowedUpgradeFields =
        new Set([
          "plan_id",
          "consumption_option",
        ]);

      const otherChanges =
        Object.entries(changedFields)
          .filter(
            ([field, value]) =>
              !allowedUpgradeFields.has(field) &&
              value !== "" &&
              value !== null &&
              !(
                Array.isArray(value) &&
                value.length === 0
              ),
          )
          .map(([field]) => field);

      if (otherChanges.length > 0) {
        showMessage(
          "Save the other subscription edits first, "
          + "then upgrade the plan separately.",
          "danger",
        );
        return;
      }

      if (testingClient && !testingClientPending) {
        setIsSaving(true);

        try {
          await Axios.post(
            `${API_URL}/radius/testing-clients/`,
            {
              action: "start",
              subscription_id: sub,
              internet_subscription_id: intsub,
              tested_plan_id: changedFields.plan_id,
              tested_consumption_option:
                changedFields.consumption_option
                || consumption_option,
            },
            {
              headers: {
                Authorization: `Bearer ${authTokens.access}`,
              },
            },
          );

          if (typeof props.fetch === "function") {
            await props.fetch();
          }

          setTestingClient(true);
          setTestingClientPending(true);
          props.closeModal();
        } catch (error) {
          console.error(error);
          showMessage(
            error.response?.data?.error
            || error.message
            || "Unable to start Testing Package.",
            "danger",
          );
        } finally {
          setIsSaving(false);
        }

        return;
      }

    const downgradeCheck = await requestDowngradeCase(changedFields);
    if (downgradeCheck === undefined) {
      return;
    }
    if (downgradeCheck) {
      const free = await isFreeAccount();
      setFreeSub(free);
      setPendingDowngradeChanges({ ...changedFields, ...(free ? { bill_free: true } : {}) });
      setDowngradeCase(downgradeCheck);
      setDowngradeReason("");
      setDowngradeReasonOpen(false);
      return;
    }

      setIsSaving(true);

      try {
        const response = await Axios.post(
          `${API_URL}/radius/subscriptions/`,
          {
            Action: "PlanUpgradeQuote",
            Subscription_id: sub,
            internet_subscription_id: intsub,
            plan_id:
              changedFields.plan_id,
            userdealer: user.username,
          },
          {
            headers: {
              Authorization:
                `Bearer ${authTokens.access}`,
            },
          },
        );

        if (
          response.data
            ?.requires_wallet_upgrade
        ) {
          const free = await isFreeAccount();
          setFreeSub(free);
          setPendingUpgradeChanges({
            ...changedFields,
            ...(free ? { bill_free: true } : {}),
          });
          setUpgradeQuote(
            response.data.quote,
          );
        } else {
          await saveSubscription(
            changedFields,
          );
        }
      } catch (error) {
        console.error(error);

        const errorMessage =
          error.response?.data?.error ||
          error.message ||
          "Unable to calculate the plan upgrade.";

        showMessage(
          errorMessage,
          "danger",
        );
      } finally {
        setIsSaving(false);
      }
      return;
    }

    setIsSaving(true);

    try {
      const response = await Axios.post(
        `${API_URL}/radius/subscriptions/`,
        {
          Action: "Put",
          Subscription_id: sub,
          internet_subscription_id: intsub,
          internet_plan_id: intplan,
          ...changedFields,
          userdealer: user.username,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        },
      );

      if (
        typeof response.data === "string" &&
        response.data.trim().startsWith("Error:")
      ) {
        throw new Error(response.data.trim());
      }

      const updatedSubscription =
        response.data?.subscription;

      if (
        !updatedSubscription ||
        updatedSubscription.subscription_id == null
      ) {
        throw new Error(
          "The backend did not return the updated subscription.",
        );
      }

      if (
        typeof props.onSubscriptionUpdated === "function"
      ) {
        props.onSubscriptionUpdated(updatedSubscription);
      } else if (typeof props.fetch === "function") {
        // Compatibility fallback for any older Formsa caller.
        await props.fetch();
      }

      props.closeModal();
    } catch (error) {
      console.error(error);
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "Unable to save the subscription changes.";
      showMessage(errorMessage, "danger");
    } finally {
      setIsSaving(false);
    }
  };

  // Function is used to searching based on input value it split the input value and check if the input value is included in the label name
  const confirmPlanUpgrade =
    async () => {
      if (
        !upgradeQuote ||
        !pendingUpgradeChanges ||
        isSaving
      ) {
        return;
      }

      const unlimitedUpgrade =
        String(o || "").trim().toUpperCase() === "LIMITED"
        && String(
          pendingUpgradeChanges.consumption_option || "",
        ).trim().toUpperCase() === "UNLIMITED";

      if (unlimitedUpgrade) {
        const fields = pendingUpgradeChanges;
        const quote = upgradeQuote;

        setUpgradeQuote(null);
        setPendingUpgradeChanges(null);

        await requestUnlimitedFee(fields, quote);
        return;
      }

      await saveSubscription(
        pendingUpgradeChanges,
        upgradeQuote,
      );
    };

  const requestUnlimitedFee = async (fields, quote = null) => {
    setIsSaving(true);

    try {
      const response = await Axios.get(
        `${API_URL}/radius/recharge_price/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
            connectivityPlan: "Unlimited Quota",
          },
        },
      );

      const fee =
        response.data?.data?.[0]?.selling_price;

      if (fee === undefined || fee === null) {
        showMessage(
          "No Unlimited Quota price is configured.",
          "danger",
        );
        return;
      }

      setPendingUnlimitedChanges({ ...fields });
      setPendingUnlimitedQuote(quote);
      setUnlimitedFee(fee);
    } catch (error) {
      console.error(error);
      showMessage(
        error.response?.data?.error
        || error.message
        || "Unable to read the Unlimited Quota price.",
        "danger",
      );
    } finally {
      setIsSaving(false);
    }
  };

  const confirmUnlimitedFee = async () => {
    if (
      unlimitedFee === null
      || !pendingUnlimitedChanges
      || isSaving
    ) {
      return;
    }

    const fields = pendingUnlimitedChanges;
    const fee = unlimitedFee;
    const quote = pendingUnlimitedQuote;

    setUnlimitedFee(null);
    setPendingUnlimitedChanges(null);
    setPendingUnlimitedQuote(null);

    await saveSubscription(fields, quote, fee);
  };

  const cancelUnlimitedFee = () => {
    if (isSaving) {
      return;
    }

    setUnlimitedFee(null);
    setPendingUnlimitedChanges(null);
    setPendingUnlimitedQuote(null);
  };

  const cancelPlanUpgrade = () => {
    if (isSaving) {
      return;
    }

    setUpgradeQuote(null);
    setPendingUpgradeChanges(null);
  };

  const customFilter = (option, inputValue) => {
    const words = inputValue.toLowerCase().split(" ");
    return words.every((word) => option.label.toLowerCase().includes(word));
  };

  const handleClientChange = (selectedOption) => {
    console.log("Selected client:", selectedOption);
    setclient(selectedOption); // Store the full selected option object

    // The rest of the client change handling remains the same
    const filteredUsernames = clients
      .filter((item) => item.client_id === selectedOption.value)
      .map((item) => ({
        label: item.username,
        value: item.subscription_id,
      }));
    setUsernames(filteredUsernames);
  };

  //Function that is based on setting consumption option,if the selected option is unlimited then the consumption option selection is disabled, else if the selected option is limited then the consumption option selection is enabled
  const handlePlanChange = (opt) => {
    setplano(opt.value);
    const unlimitedPlans = ["PREMIUM", "GOLD", "PLATINUM", "DIAMOND"];
    if (unlimitedPlans.includes(opt.label)) {
      setplano(opt.value);
      setcon("UNLIMITED");
      setConsumptionDisabled(true);
    } else {
      setcon("LIMITED");
      setConsumptionDisabled(false);
    }
  };

  //function that copies of the password and shows the message that the password is copied
  const copyPassword = () => {
    const textToCopy = password || pass;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        showMessage("Password copied!", "success");
      });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        showMessage("Password copied!", "success");
      } catch (err) {
        showMessage("Failed to copy password", "danger");
      }
      document.body.removeChild(textArea);
    }
  };

  //functions that handles the change of connecctivity and if the selected connectivity is wireless then the site selection is enabled, else if the selected connectivity is fiber then the site selection is disabled
  const handleConnectivityChange = (opt) => {
    setcona(opt.value);

    if (opt.value !== "Wireless") {
      setSelectedSite("");
      setSelectedSiteLabel("");
      setWirelessAccessPoint("");
      setSelectedWirelessAccessPointLabel("");
      setWirelessAccessPoints([]);
    }

    if (opt.value !== "Fiber") {
      setSelectedCore("");
      setSelectedCoreLabel("");
    }
  };

  //Function that handles the change of site and if the selected site is selected then the wireless access points are fetched based on the selected site
  const handleSiteChange = (opt) => {
    setSelectedSite(opt.value);
    const selectedSite = sites.find(
      (selectedSite) => selectedSite.value === opt.value,
    )?.label;
    setSelectedSiteLabel(opt.label);
    setWirelessAccessPoint("");
    setSelectedWirelessAccessPointLabel("");

    if (selectedSite) {
      setWirelessAccessPoints([]);
      fetchWirelessAccessPoints(selectedSite);
    }
  };

  const isValidMacAddress = (value) => {
    const macRegex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;
    return macRegex.test(value);
  };

  useEffect(() => {
    setCpeError(
      cpeMacAddress && !isValidMacAddress(cpeMacAddress)
        ? "Invalid CPE MAC Address format"
        : "",
    );
  }, [cpeMacAddress]); // CPE MAC Address Validation Use Effect

  const handleAddMac = async () => {
    console.log("Add MAC Address clicked");
    try {
      const payload = {
        subscription_id: sub,
        internet_subscription_id: intsub,
        cpe_mac_address: cpeMacAddress,
        userdealer: user.username,
        site_id: selectedSite || null, // pass selected site
        ap_id: wirelessAccessPoint || null, // pass selected AP
        connectivity: connectivity || null, // pass selected connectivity
      };
      const response = await Axios.post(
        `${API_URL}/radius/cpemacaddress/add/`,
        payload,
        { headers: { Authorization: `Bearer ${authTokens.access}` } },
      );

      console.log(response);
      if (response.data.status) {
        showMessage(response.data.status, "success");
      }
    } catch (error) {
      console.error(error);
      const errMsg =
        error.response?.data?.error || "Error adding CPE MAC address";
      showMessage(errMsg, "danger");
    }
  };

  const handleRemoveMac = async () => {
    console.log("Remove MAC Address clicked");
    try {
      const response = await Axios.post(
        `${API_URL}/radius/cpemacaddress/remove/`,
        {
          subscription_id: sub, // Your subscription ID
          internet_subscription_id: intsub, // Your internet subscription ID
          userdealer: user.username,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        },
      );
      console.log(response);
      // Display success message returned from backend
      if (response.data.status) {
        showMessage(response.data.status, "success");
        // Optionally, update your state if you need to reflect the removal,
        // for example, resetting the cpeMacAddress to an empty string or "-" based on your UX.
        setCpeMacAddress("-");
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data.error) {
        showMessage(error.response.data.error, "danger");
      } else {
        showMessage("Error removing CPE MAC address", "danger");
      }
    }
  }; // Remove MAC Address Function

  const effectiveCpeMacAddress = cpeMacAddress || cpe || "";
  const hasExistingCpeMacAddress =
    effectiveCpeMacAddress.trim() !== "" &&
    effectiveCpeMacAddress.trim() !== "-";

  const handleCopyCPE = () => {
    const input = document.createElement("input");
    input.value = effectiveCpeMacAddress;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
  }; // Copy CPE Function

  const showMacControls =
    connectivity === "Wireless" &&
    !specialSites.includes(selectedSiteLabel);

  const saveButton = (
    <button
      type="submit"
      className="subscription-save-button"
      disabled={!isDirty || isSaving}
    >
      {isSaving ? "Saving..." : "Save Changes"}
    </button>
  );

  return (
    <div className="testi">
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
      ></link>
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              Username:
              <input
                className="form-control"
                type="text"
                value={username}
                placeholder={u}
                onChange={(e) => setusername(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Password:
              <div className="input-group">
                <input
                  className="form-control"
                  type="text"
                  value={password}
                  placeholder={pass}
                  onChange={(e) => setpassword(e.target.value)}
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={copyPassword}
                    style={{
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      marginLeft: "5px",
                    }}
                  >
                    <i className="fas fa-copy"></i>
                  </button>
                </div>
              </div>
            </label>
          </div>
          <div className="form-group">
            <label>
              Client Name:
              <Select
                className="search-line" classNamePrefix="subscription-edit-select"
                placeholder={f}
                options={options}
                onChange={handleClientChange}
                filterOption={customFilter}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Plan Name:
              <Select
                className="search-line" classNamePrefix="subscription-edit-select"
                placeholder={p}
                options={plano}
                onChange={handlePlanChange}
              />
            </label>
          </div>
            <div className="form-group subscription-testing-client-field">
              <label className="subscription-testing-client-label">
                <input
                  type="checkbox"
                  checked={testingClient}
                  onChange={(event) => (
                    setTestingClient(event.target.checked)
                  )}
                  disabled={
                    isSaving ||
                    testingClientLoading ||
                    testingClientPending
                  }
                />
                <span>Testing Package</span>
              </label>
            </div>
          <label>
            Consumption Option:
            <Select
              className="search-line" classNamePrefix="subscription-edit-select"
              options={opta}
              value={{ label: consumption_option, value: consumption_option }}
              isDisabled={consumptionDisabled}
              onChange={(opt) => setcon(opt.value)}
            />
          </label>
          <label>
            Quota Option:
            <Select
              className="search-line" classNamePrefix="subscription-edit-select"
              options={quota}
              value={{ label: quota_option, value: quota_option }}
              isDisabled={consumptionDisabled}
              onChange={(opt) => setquota(opt.value)}
            />
          </label>

          <label>
            Site/Core:
            <input
              className="form-control"
              type="text"
              value={site}
              placeholder={s}
              onChange={(e) => setsite(e.target.value)}
            />
          </label>
          <label>
            Suffix:
            <input
              className="form-control"
              type="text"
              value={suffix}
              onChange={(e) => setsuffix(e.target.value)}
            />
          </label>
          <label>
            Due Date:
            <Select
              placeholder={du}
              className="search-line" classNamePrefix="subscription-edit-select"
              options={dua}
              onChange={(opt) => setdue(opt.value)}
            />
          </label>
          <label>
            Labels:
            <Select
              className="search-line" classNamePrefix="subscription-edit-select"
              options={labelss}
              isMulti
              value={selectedLabelOptions}
              onChange={(opts) => {
                const nextOptions = opts || [];
                const nextNames = nextOptions
                  .map((option) => option.label)
                  .sort();

                const matchesOriginal =
                  JSON.stringify(nextNames) ===
                  JSON.stringify(originalLabelNames);

                setlabel(
                  matchesOriginal
                    ? null
                    : nextOptions.map((option) => option.value),
                );
              }}
            />
          </label>
          <div
            className="form-group"
            style={{ display: "flex", alignItems: "center" }}
          >
            <label style={{ marginRight: "10px" }}>Full Quota:</label>
            <input
              type="checkbox"
              checked={full_option === 1}
              onChange={(e) => setfull(e.target.checked ? 1 : 0)}
              style={{ width: "20px", height: "20px" }}
            />
          </div>
          <label>
            Expiry Date:
            <input
              type="date"
              id="expiryDate"
              name="expiryDate"
              className="form-control"
              defaultValue={exp ? exp.substr(0, 10) : ""}
              onChange={(e) => setda(e.target.value)}
              disabled={!expiryDateDisabled}
            />
          </label>
          <label>
            Payment Date:
            <input
              type="date"
              id="paymentDate"
              name="paymentDate"
              className="form-control"
              defaultValue={paymentDate ? paymentDate.substr(0, 10) : ""}
              onChange={(e) => setpa(e.target.value)}
            />
          </label>
          <label>
            Connectivity Option:
            <Select
              className="search-line" classNamePrefix="subscription-edit-select"
              placeholder={c}
              options={cona}
              onChange={(opt) => {
                handleConnectivityChange(opt);
              }}
            />
          </label>

          {/* Show Site options if connectivity is "Wireless" */}
          {(connectivity === "Wireless" || c === "Wireless") &&
            connectivity !== "Fiber" && (
              <label>
                Site:
                <Select
                  className="search-line" classNamePrefix="subscription-edit-select"
                  placeholder={site_name}
                  options={sites}
                  onChange={(opt) => {
                    handleSiteChange(opt);
                  }}
                />
              </label>
            )}

          {/* Show Wireless Access Point options if Site is selected */}
          {(connectivity === "Wireless" || c === "Wireless") &&
            connectivity !== "Fiber" &&
            !specialSites.includes(selectedSiteLabel) && (
              <label>
                Wireless Access Point:
                <Select
                  className="search-line" classNamePrefix="subscription-edit-select"
                  placeholder={w}
                  options={wirelessAccessPoints}
                  onChange={(opt) => {
                    setWirelessAccessPoint(opt.value);
                    setSelectedWirelessAccessPointLabel(opt.label);
                  }}
                />
              </label>
            )}
          {(connectivity === "Fiber" || c === "Fiber") &&
            connectivity !== "Wireless" && (
              <label>
                Core:
                <Select
                  className="search-line" classNamePrefix="subscription-edit-select"
                  placeholder={core}
                  options={cores}
                  onChange={(opt) => {
                    setSelectedCore(opt.value);
                    setSelectedCoreLabel(opt.label);
                  }}
                />
              </label>
            )}
          {/* Show CPE MAC controls for non-special wireless subscriptions. */}
          {showMacControls && (
              <div className="me-3">
                <label className="form-label">CPE MAC Address:</label>
                <div className="d-flex align-items-center">
                  <input
                    type="text"
                    className={`form-control ${cpeError ? "is-invalid" : ""}`}
                    style={{ width: "250px" }}
                    value={cpeMacAddress}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const rawNoCols = raw.replace(/:/g, "");
                      const cleaned = rawNoCols.replace(/[^0-9A-Fa-f]/g, "");

                      // if characters were dropped, it means a non‑hex was typed
                      setCpeError(cleaned.length !== rawNoCols.length);

                      // format into pairs + colons, uppercase, max 12 hex digits
                      let formatted = "";
                      for (let i = 0; i < cleaned.length && i < 12; i += 2) {
                        if (i > 0) formatted += ":";
                        formatted += cleaned.substring(i, i + 2).toUpperCase();
                      }
                      setCpeMacAddress(formatted);
                    }}
                    maxLength={17} // “AA:BB:CC:DD:EE:FF”
                    placeholder={cpe}
                  />

                  <button
                    type="button"
                    className="btn btn-outline-primary rounded-end"
                    onClick={handleCopyCPE}
                  >
                    <i className="fas fa-copy" />
                  </button>

                  <button
                    type="button"
                    className={`btn ms-2 ${
                      hasExistingCpeMacAddress
                        ? "btn-danger"
                        : "btn-success"
                    }`}
                    onClick={
                      hasExistingCpeMacAddress
                        ? handleRemoveMac
                        : handleAddMac
                    }
                  >
                    {hasExistingCpeMacAddress
                      ? "Remove Mac Address"
                      : "Add Mac Address"}
                  </button>

                  {saveButton}
                </div>

                {cpeError && (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block", fontSize: "0.85rem" }}
                  >
                    Only hexadecimal digits (0–9, A–F) are allowed.
                  </div>
                )}
              </div>
            )}

          {!showMacControls && (
            <div className="subscription-save-fallback">
              {saveButton}
            </div>
          )}
        </form>
      </div>

      {unlimitedFee !== null && (
        <div
          className="oss-plan-upgrade-backdrop"
          role="presentation"
          onMouseDown={(event) => {
            if (
              event.target
              === event.currentTarget
            ) {
              cancelUnlimitedFee();
            }
          }}
        >
          <section
            className="oss-plan-upgrade-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="oss-unlimited-fee-title"
          >
            <header
              className="oss-plan-upgrade-header"
            >
              <div>
                <h3 id="oss-unlimited-fee-title">
                  Confirm Unlimited Quota
                </h3>
                <p>
                  {"LIMITED"}
                  {" \u2192 "}
                  {"UNLIMITED"}
                </p>
                {subDiscounts.map((d) => (
                  <p key={d.discount_id}>{discountLine(d)}</p>
                ))}
              </div>

              <button
                type="button"
                className="oss-plan-upgrade-close"
                onClick={cancelUnlimitedFee}
                aria-label="Close"
                disabled={isSaving}
              >
                &times;
              </button>
            </header>

            <div
              className="oss-plan-upgrade-body"
            >
              <div
                className="oss-plan-upgrade-row"
              >
                <span>Unlimited Quota fee</span>
                <strong>
                  ${unlimitedFee}
                </strong>
              </div>
              {freeSub && (
                <div className="oss-plan-upgrade-row">
                  <strong>{freeText("body")}</strong>
                </div>
              )}
            </div>

            <footer
              className="oss-plan-upgrade-footer"
            >
              <button
                type="button"
                onClick={cancelUnlimitedFee}
                disabled={isSaving}
                style={freeSub ? { marginRight: "auto" } : undefined}
              >
                {freeSub ? freeText("cancel") : "No"}
              </button>
              {freeSub && (
                <button
                  type="button"
                  onClick={() => saveFreeNoBill(pendingUnlimitedChanges)}
                  disabled={isSaving}
                >
                  {freeText("ok")}
                </button>
              )}

              <button
                type="button"
                onClick={confirmUnlimitedFee}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : freeSub ? freeText("bill") : "Yes"}
              </button>
            </footer>
          </section>
        </div>
      )}

      {downgradeCase && (
        <div
          className="oss-plan-upgrade-backdrop"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              cancelDowngrade();
            }
          }}
        >
          <section
            className="oss-plan-upgrade-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="oss-downgrade-title"
          >
            <header className="oss-plan-upgrade-header">
              <div>
                <h3 id="oss-downgrade-title">{downgradeText("title")}</h3>
                <p>
                  {downgradeCase.old_plan_name}
                  {" \u2192 "}
                  {downgradeCase.new_plan_name}
                </p>
                {subDiscounts.map((d) => (
                  <p key={d.discount_id}>{discountLine(d)}</p>
                ))}
              </div>

              <button
                type="button"
                className="oss-plan-upgrade-close"
                onClick={cancelDowngrade}
                aria-label="Close"
                disabled={isSaving}
              >
                &times;
              </button>
            </header>

            <div className="oss-plan-upgrade-body">
              <div className="oss-plan-upgrade-row">
                <span>{downgradeText("body")}</span>
              </div>
              {downgradeReasonOpen && (
                <div className="oss-plan-upgrade-row">
                  <span>{downgradeText("reasonIntro")}</span>
                  <textarea
                    value={downgradeReason}
                    onChange={(event) => setDowngradeReason(event.target.value)}
                    placeholder={downgradeText("reason")}
                    rows={3}
                    style={{ width: "100%" }}
                    disabled={isSaving}
                  />
                </div>
              )}
              {freeSub && (
                <div className="oss-plan-upgrade-row">
                  <strong>{freeText("body")}</strong>
                </div>
              )}
            </div>

            <footer className="oss-plan-upgrade-footer">
              {freeSub && (
                <>
                  <button
                    type="button"
                    onClick={cancelDowngrade}
                    disabled={isSaving}
                    style={{ marginRight: "auto" }}
                  >
                    {freeText("cancel")}
                  </button>
                  <button
                    type="button"
                    onClick={() => saveFreeNoBill(pendingDowngradeChanges)}
                    disabled={isSaving}
                  >
                    {freeText("ok")}
                  </button>
                </>
              )}
              {downgradeCase.case === "unpaid_late" ? (
                downgradeReasonOpen ? (
                  <>
                    <button
                      type="button"
                      onClick={() => setDowngradeReasonOpen(false)}
                      disabled={isSaving}
                    >
                      {downgradeText("back")}
                    </button>
                    <button
                      type="button"
                      onClick={() => confirmDowngrade("cancel_invoice")}
                      disabled={isSaving}
                    >
                      {isSaving ? "Saving..." : downgradeText("confirmCancel")}
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={() => confirmDowngrade("keep_invoice")}
                      disabled={isSaving}
                    >
                      {isSaving ? "Saving..." : downgradeText("continue")}
                    </button>
                    <button
                      type="button"
                      onClick={() => setDowngradeReasonOpen(true)}
                      disabled={isSaving}
                    >
                      {downgradeText("cancelAndContinue")}
                    </button>
                  </>
                )
              ) : (
                <>
                  <button
                    type="button"
                    onClick={cancelDowngrade}
                    disabled={isSaving}
                  >
                    {downgradeText("no")}
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      confirmDowngrade(
                        downgradeCase.case === "paid_within"
                          ? "credit_difference"
                          : "cancel_invoice",
                      )
                    }
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : downgradeText("yes")}
                  </button>
                </>
              )}
            </footer>
          </section>
        </div>
      )}

      {upgradeQuote && (
        <div
          className="oss-plan-upgrade-backdrop"
          role="presentation"
          onMouseDown={(event) => {
            if (
              event.target
              === event.currentTarget
            ) {
              cancelPlanUpgrade();
            }
          }}
        >
          <section
            className="oss-plan-upgrade-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="oss-plan-upgrade-title"
          >
            <header
              className="oss-plan-upgrade-header"
            >
              <div>
                <h3 id="oss-plan-upgrade-title">
                  Confirm Plan Upgrade
                </h3>
                <p>
                  {upgradeQuote.old_plan_name}
                  {" → "}
                  {upgradeQuote.new_plan_name}
                </p>
                {subDiscounts.map((d) => (
                  <p key={d.discount_id}>{discountLine(d)}</p>
                ))}
              </div>

              <button
                type="button"
                className="oss-plan-upgrade-close"
                onClick={cancelPlanUpgrade}
                aria-label="Close"
                disabled={isSaving}
              >
                ×
              </button>
            </header>

            <div
              className="oss-plan-upgrade-body"
            >
              <div
                className="oss-plan-upgrade-row"
              >
                <span>Days remaining</span>
                <strong>
                  {upgradeQuote.remaining_days}
                </strong>
              </div>

              <div
                className="oss-plan-upgrade-row"
              >
                <span>
                  Unused{" "}
                  {upgradeQuote.old_plan_name}
                  {" value"}
                </span>
                <strong
                  className={
                    "oss-plan-upgrade-credit"
                  }
                >
                  −${upgradeQuote.unused_credit}
                </strong>
              </div>

              <div
                className={
                  "oss-plan-upgrade-formula"
                }
              >
                ${upgradeQuote.old_price}
                {" × "}
                {upgradeQuote.remaining_days}
                {" / 30"}
              </div>

              <div
                className="oss-plan-upgrade-row"
              >
                <span>
                  {upgradeQuote.new_plan_name}
                  {" for remaining period"}
                </span>
                <strong>
                  +$
                  {upgradeQuote.remaining_charge}
                </strong>
              </div>

              <div
                className={
                  "oss-plan-upgrade-formula"
                }
              >
                ${upgradeQuote.new_price}
                {" × "}
                {upgradeQuote.remaining_days}
                {" / 30"}
              </div>

              <div
                className={
                  "oss-plan-upgrade-total"
                }
              >
                <span>
                  Net amount added to
                  client balance
                </span>
                <strong>
                  ${upgradeQuote.net_due}
                </strong>
              </div>

              <div
                className={
                  "oss-plan-upgrade-balance"
                }
              >
                <span>
                  Balance: $
                  {upgradeQuote.wallet_before}
                  {" → $"}
                  {upgradeQuote.wallet_after}
                </span>
                <span>
                  Expiry remains{" "}
                  {upgradeQuote.expiry_date}
                </span>
              </div>
              {freeSub && (
                <div className="oss-plan-upgrade-row">
                  <strong>{freeText("body")}</strong>
                </div>
              )}
            </div>

            <footer
              className="oss-plan-upgrade-footer"
            >
              <button
                type="button"
                className={
                  "oss-plan-upgrade-button "
                  + "secondary"
                }
                onClick={cancelPlanUpgrade}
                disabled={isSaving}
                style={freeSub ? { marginRight: "auto" } : undefined}
              >
                {freeSub ? freeText("cancel") : "Cancel"}
              </button>
              {freeSub && (
                <button
                  type="button"
                  className={
                    "oss-plan-upgrade-button "
                    + "secondary"
                  }
                  onClick={() => saveFreeNoBill(pendingUpgradeChanges)}
                  disabled={isSaving}
                >
                  {freeText("ok")}
                </button>
              )}

              <button
                type="button"
                className={
                  "oss-plan-upgrade-button "
                  + "primary"
                }
                onClick={confirmPlanUpgrade}
                disabled={isSaving}
              >
                {isSaving
                  ? "Upgrading..."
                  : freeSub ? freeText("bill") : "Confirm Upgrade"}
              </button>
            </footer>
          </section>
        </div>
      )}

      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default Formsa;
